import { Link, Outlet } from '@remix-run/react';

export default function Liquidity() {
   return (
         <Outlet />
   );
}
